import React, { FunctionComponent, useEffect, useState } from 'react';
import { DatabaseStore } from './platform/libby/DatabaseStore';
import { JetUser, SessionChangeEmitter } from './platform/libby/session';
import { PhinxApp } from './lib/profiles/PhinxApp';
import { useProfileContext } from './lib/profiles/ProfileContext';
import { Loading } from './commons/components/Loading';
import { Analytics } from './platform/analytics';
import { useRolesContext } from './context';
import { APP_ECOMMERCE, HOTJAR_ENABLED } from './config';

// Initialize Libby
DatabaseStore.init();

// Trackers
// TODO : pasar id segun ecommerse
Analytics.initialize('UA-190202452-4');

export const App: FunctionComponent = () => {
  const [isFirstLoading, setIsFirstLoading] = useState(true);
  const [initialProfileLoaded, setInitialProfileLoaded] = useState(false);
  const [isLogged, setIsLogged] = useState<boolean | undefined>(undefined);
  const { setProfile } = useProfileContext();
  const { setUserInfo, setSelectedRole } = useRolesContext();
  const idNovastore = 6406841
  const idEnova = 6406847

  useEffect(() => {
      if (!HOTJAR_ENABLED) return;
      const hotjarId = APP_ECOMMERCE === 'enova' ? idEnova : idNovastore;

      if (!hotjarId) return;

      (function hotjar(h: any, o: Document, t: string, j: string) {
        h.hj =
          h.hj ||
           function hotjarQueue(...args: any[]) {
            (h.hj.q = h.hj.q || []).push(args);
          };
        h._hjSettings = { hjid: Number(hotjarId), hjsv: 6 };

        const head = o.getElementsByTagName('head')[0];
        const script = o.createElement('script');
        script.async = true;
        script.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        head.appendChild(script);
      })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=');
  }, []);

  useEffect(
    () =>
      SessionChangeEmitter.subscribe(({ isLogged: logged, user }: { isLogged: boolean; user: JetUser }) => {
        // Esta logica es para manejar la seleccion del rol y la seleccion de las reglas de permiso
        if (logged) {
          setUserInfo(user);
          const rol = {
            rol_id: user.groups[0].id,
            rol_name: user.groups[0].name,
          };
          setSelectedRole(rol);
        }
        // if (user.groupSelected) {
        //   desactivateAllRulesSets();
        //   activateRulesSet(`rol-${user.groupSelected.rol.id}`);
        //   activateRulesSet(`nivel-${user.groupSelected.nivel.idNivel}`);
        //   setSelectedRole({});
        // } else {
        //   desactivateAllRulesSets();
        // }
        setIsLogged(logged);
        setTimeout(() => setIsFirstLoading(false), 0);
      }),
    [setUserInfo, setSelectedRole],
  );

  useEffect(() => {
    if (!isFirstLoading) {
      if (!isLogged) {
        setProfile('public');
      } else {
        setProfile('private');
      }
      setInitialProfileLoaded(true);
    }
  }, [isFirstLoading, isLogged, setProfile]);

  return !initialProfileLoaded ? <Loading /> : <PhinxApp />;
};
